import { createSearch } from './search'
import { merge } from 'lodash'

export function createList(client, resource, options) {

  const search = createSearch(client, resource, merge({
    options: {
      itemsPerPage: null,
    },
    watchOptions: false,
  }, options))

  function findItem(callback, thisArg) {
    return search.items.value.find(callback, thisArg)
  }

  function filterItems(callback, thisArg) {
    return search.items.value.filter(callback, thisArg)
  }

  if (options && options.search) {
    search.search()
  }

  return {
    ...search,
    findItem,
    filterItems,
  }


}